import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=ba4dece4&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=ba4dece4&prod&lang=scss&scoped=true"
import style1 from "./RoleList.vue?vue&type=style&index=1&id=ba4dece4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4dece4",
  null
  
)

export default component.exports